import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Form } from '../../entities/forms/form';
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})

export class FormService {
  // Define API
  apiURL = environment.apiUrl;

  constructor(private http: HttpClient) { }
  /*========================================
  CRUD Methods for consuming RESTful API
  =========================================*/
  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  // HttpClient API get() method => Fetch forms list
  getForms(): Observable<Form> {
    return this.http.get<Form>(this.apiURL + '/getformulario')
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getFormsUser(idUser): Observable<Form> {
    return this.http.get<Form>(this.apiURL + '/getformulariousuarioParm?usuario_realgisId=' + idUser)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // HttpClient API get() method => Fetch form
  getForm(id): Observable<Form> {
    return this.http.get<Form>(this.apiURL + '/formulario/' + id)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // HttpClient API post() method => Create form
  createForm(form): Observable<Form> {
    return this.http.post<Form>(this.apiURL + '/formulario/0', JSON.stringify(form), this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  // HttpClient API put() method => Update form
  updateForm(id, form): Observable<Form> {
    return this.http.put<Form>(this.apiURL + '/formulario/' + id, JSON.stringify(form), this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  // HttpClient API delete() method => Delete form
  deleteForm(id) {
    return this.http.delete<Form>(this.apiURL + '/formulario/' + id, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // Error handling
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code (form): ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}
